import * as types from "./../types";
import RetrieveService from "../../services/Retrieve.Service";
import { funcUpdateAppStateAfterResponse } from "./AppStateActions";
import { funcGenerateUniqueKey, getAddress, getVisionAddress,getGEMID1,getGEMID2,getTrackState, getTitanEncircleCard} from '../../shared/utility';
import { getScreen, getSSLData, getUserDetails } from "../../shared/TrackRetUtility";
//import SslService from "./../../services/Ssl.Service";
import { funcStoreVisionAddress } from "../actions/SslActions";
import { isPartnerChannelCode, getPartnerAddress } from '../../shared/PartnerUtility';
import { getC2BRetargetChannel, getC2BChannel, getGemidId2ValueFromService, getC2BGemid2Channel } from "../../shared/SharedUtility";
const initState = {
    isSaved: true,
    currentAction: "",
    isSubmited: false,
    isSubmitedSuccess: false,
    loading: false,
    error: null,
};
let payload = {};
let errorState = {};

export const funcRetrieveApplication = (value) => async (dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });

    const inputData = { hsToken: value, dsignString: funcGenerateUniqueKey() };
    const response = await RetrieveService.funcRetrieveApp(inputData);

    if (response && response.data) {
        const dataset = response.data.data;
        if (response.data.statusCode === "000" || response.data.statusCode === "002") {
            dataset['mobileNo'] = response.data.data?.mobileNumber;
            delete dataset.mobileNumber;
            if (!response.data.data?.cardType) {
                dataset['cardType'] = "";
            }
            if(dataset.isDumpBased==="Y")
                dispatch({ type: types.SAVE_IS_DUMP_BASED, payload:true});
             /***********Gemid Updation Starts********************/
            let gemid1 ="";
            let gemid2 ="";
            let localStorgemid1 = getGEMID1();
            let localStorgemid2 = getGEMID2();
            const c2bRetargetIdentifier = "C2B";
            if(localStorgemid1 && localStorgemid1.includes(c2bRetargetIdentifier)){
                let retrieveRespnsegemId1 = getC2BRetargetChannel(response.data.data.gemId1);
                localStorgemid1 = getC2BChannel(localStorgemid1);
                localStorgemid1 = localStorgemid1.replace(/_+$/,'');
                gemid1 =  retrieveRespnsegemId1 ? localStorgemid1+":"+retrieveRespnsegemId1 : localStorgemid1;
                localStorage.setItem("gemId1", gemid1);
            }else{
                gemid1 = response.data?.data?.gemId1 ? response.data.data.gemId1 : "";
            }
            if(localStorgemid2 && localStorgemid2.includes(c2bRetargetIdentifier)){
               /* let retrieveRespnsegemId2 = getC2BRetargetChannel(response.data.data.gemId2);
                localStorgemid2 = getC2BChannel(localStorgemid2);
                localStorgemid2 = localStorgemid2.replace(/_+$/,'');
                gemid2 =  retrieveRespnsegemId2 ? localStorgemid2 +":"+ retrieveRespnsegemId2 : localStorgemid2;
                localStorage.setItem("gemId2", gemid2); */
                let retrieveRespnsegemId2 = getGemidId2ValueFromService(response.data.data.gemId2);
                localStorgemid2 = getC2BGemid2Channel(localStorgemid2);
                localStorgemid2 = localStorgemid2.replace(/_+$/,'');
                gemid2 =  retrieveRespnsegemId2 ? retrieveRespnsegemId2 +":"+ localStorgemid2 : localStorgemid2;
                localStorage.setItem("gemId2", gemid2); 
            }else{
                gemid2 = response.data?.data?.gemId2 ? response.data.data.gemId2 : ""; 
            }
            /**************Gemid Updation Ends******************/
            // when non consented lead comes from Eapply home page by retrieve
            const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
            if(lg_lite_partner_chanel.includes(dataset['channelCode']) && (dataset['consentFlag']==="Y" || (localStorgemid2 &&  localStorgemid2.includes(c2bRetargetIdentifier)) || (localStorgemid1 && localStorgemid1.includes(c2bRetargetIdentifier))))
            localStorage.setItem("sourceCode","DC");
            else if(getTitanEncircleCard(dataset['cardType']) && ((localStorgemid2 &&  localStorgemid2.includes(c2bRetargetIdentifier)) || (localStorgemid1 && localStorgemid1.includes(c2bRetargetIdentifier))))
            localStorage.setItem("sourceCode","DC");// when Titan lead is coming from C2b link
            let userPayLoad = null;
            if (gemid1 !== "" && gemid2 !== "") {
                userPayLoad = { ...dataset, gemId1: gemid1, gemId2: gemid2 };
                //const reqPayload = { shortCode: dataset?.shortCode, gemId1: gemid1, gemId2: gemid2 };
                // SslService.funcUpdateSSLByShortCodev1(reqPayload, "updateC2BGemId");
            };
            if(response.data.data?.cardType && response.data.data?.cardType !== "")
            dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:response.data.data?.cardType});
            dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: userPayLoad ? userPayLoad : dataset });
            const sslData = getSSLData(response.data.data);
            if (response.data.data?.shortCode) {
            localStorage.setItem("shortCode", response.data.data.shortCode);
            }
            
            dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: sslData }, });

            if (response.data?.data?.vPlusAddress) {
                let res = {
                    vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
                    visionMothersName: response.data?.data && response.data?.data?.vPlusMotherName ? response.data?.data?.vPlusMotherName : "",
                    visionEmailId: response.data?.data && response.data?.data?.vPlusEmailId ? response.data?.data?.vPlusEmailId : "",
                    dSignVPlusMotherName: response.data?.data && response.data?.data?.dSignVPlusMotherName ? response.data?.data?.dSignVPlusMotherName : "",
                    dSignVPlusEmailId: response.data?.data && response.data?.data?.dSignVPlusEmailId ? response.data?.data?.dSignVPlusEmailId : "",
                    dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
                };
                let vAddress = res.vPlusAddress;
                const vPlusResiAddress = getVisionAddress(vAddress);
                dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
            }

            const screenDetails = getScreen(sslData);
            payload = { ...initState, isSubmited: true, isUserRetrieve: true, screenName: screenDetails.goTo, loading: false, };
            errorState = null;
        } else if (response.data.statusCode === "003") {
             /*******************************/
             const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
             if(lg_lite_partner_chanel.includes(dataset['channelCode']))
             localStorage.setItem("sourceCode","DC");
             let gemid1 ="";
             let gemid2 ="";
             let localStorgemid1 = getGEMID1();
             let localStorgemid2 = getGEMID2();
             const c2bRetargetIdentifier = "C2B";
             if(localStorgemid1 && localStorgemid1.includes(c2bRetargetIdentifier)){
                let retrieveRespnsegemId1 = getC2BRetargetChannel(response.data.data.gemId1);
                localStorgemid1 = getC2BChannel(localStorgemid1);
                localStorgemid1 = localStorgemid1.replace(/_+$/,'');
                gemid1 =  retrieveRespnsegemId1 ? localStorgemid1+":"+retrieveRespnsegemId1 : localStorgemid1;
                localStorage.setItem("gemId1", gemid1);
             }
             if(localStorgemid2 && localStorgemid2.includes(c2bRetargetIdentifier)){
                let retrieveRespnsegemId2 = getGemidId2ValueFromService(response.data.data.gemId2);
                // retrieveRespnsegemId2 = getGemid2LeadSource(retrieveRespnsegemId2,response.data.data.leadSource);
                localStorgemid2 = getC2BGemid2Channel(localStorgemid2);
                localStorgemid2 = localStorgemid2.replace(/_+$/,'');
               // gemid2 =  retrieveRespnsegemId2 ? localStorgemid2 +":"+ retrieveRespnsegemId2 : localStorgemid2;
                gemid2 =  retrieveRespnsegemId2 ? retrieveRespnsegemId2 +":"+ localStorgemid2 : localStorgemid2;
                localStorage.setItem("gemId2", gemid2); 
             }

             if(dataset.blazeFungibleFlag ==='Y'){
                const fungibleData = {
                    fungibleFlag : dataset.blazeFungibleFlag, 
                    fungibleCurrLimit : dataset.fungibleCurrXpos , 
                    fungibleIncLimit : dataset.fungibleIncLimit
                }
                dispatch({ type: types.SAVE_FUNGIBLE_DATA, payload: fungibleData});
            }
            if(dataset?.differentlyAbledStatus !== undefined && dataset?.differentlyAbledStatus !== null && dataset?.differentlyAbledStatus !== false){
                const disabilityData = {
                    "differentlyAbledStatus": dataset?.differentlyAbledStatus,
                    "udidNumber": dataset?.udidNumber,
                    "typeOfImpairment": dataset?.typeOfImpairment,
                    "percentageOfImpairment": dataset?.percentageOfImpairment,
                    "brailleCard": dataset?.brailleCardRequired ? dataset?.brailleCardRequired : null
                }
                dispatch({type : types.LOCAL_DISABILITY_DATA , payload:disabilityData});
            }
             /********************************/
            // const user = getUserDetails(response.data.data);
            // dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: user, });
            // dispatch({ type: types.SAVE_CKYC_DATA, payload: { applicationNumber: response.data.data?.applicationNumber }, });
            // payload = { ...initState, isSubmited: true, isUserRetrieve: true, loading: false, };
            // errorState = null;
            let user = getUserDetails(response.data.data);
            if (response.data.data?.shortCode) {
                localStorage.setItem("shortCode", response.data.data.shortCode);
            }
           
            if (response.data?.data?.vPlusAddress) {
                let res = {
                    vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
                    dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
                };
                let vAddress = res.vPlusResiAddress;
                const vPlusResiAddress = getVisionAddress(vAddress);
                dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
            }
            if(dataset.dumpAppFlag && dataset.dumpAppFlag==="Y")
                dispatch({ type: types.SAVE_IS_DUMP_BASED, payload: true});
            if(response.data.data.earlyCreditDecPartner && response.data.data.earlyCreditDecPartner === 'Y'){
                dispatch({type : types.SAVE_EARLY_CREDIT_FLAG , payload :response.data.data.earlyCreditDecPartner})
            }
           
            
            dispatch({
                type: types.SAVE_CKYC_DATA,
                payload: { applicationNumber: response.data.data?.applicationNumber, gender: response.data.data?.ckycGender },
            });

            if (isPartnerChannelCode(response.data?.data?.channelCode) || (response.data.data?.earlyCreditDecPartner && response.data.data?.earlyCreditDecPartner === 'Y')) {
               
                dispatch({
                    type: types.SAVE_PARTNER_DATA,
                    payload: {
                        channelCode: response.data?.data?.channelCode,
                        contactDetails: getPartnerAddress(response.data?.data?.contactDetails),
                        inbmitcScreen: response.data?.data?.inbmitcScreen,
                        autoSweepReceived:response.data?.data?.autoSweepDetailsBO?.autoSweepReceived,
                        autoDebitReceived:response.data?.data?.autoDebitDetailsBO?.autoDebitReceived,
                        paymentOption:response.data?.data?.autoDebitDetailsBO?.paymentOption,
                        blazeAdFlag:response.data?.data?.blazeAdFlag,
                        blazeAsFlag:response.data?.data?.blazeAsFlag,
                        accNoOnAutoDebit:response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit ?response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit:"XXXXXXXXXXXX" ,
                        platformIndicator: response.data?.data?.platformIndicator,
                        inbFlag: response.data?.data?.inbFlag,
                        partnerUUID: response.data?.data?.partnerUUID,
yonoUUID: response.data?.data?.yonoUUID,
                        fdAccountNo: response.data?.data?.fdAccountNo,
                        savingsAccountNo: response.data?.data?.savingsAccountNo,
                        holdAmount: response.data?.data?.holdAmount,
                    }
                });
            }
            dispatch({  type: types.SAVE_TELCO_FLAGS_FOR_EKYC_JOURNEY, payload: {
                ekycJourneytelcoFLag: dataset['telcoFLag'],// saving telco flag to pass in kyc search for banka 
                ekycJourneytelcoReason: dataset['telcoReason']
            }});
            if (response.data.data?.stpAddressList && response.data.data?.stpAddressList.length) {
                    dispatch({
                        type: types.SAVE_DIGILOCKER_DATA,
                        payload: {
                            gender: response.data.data?.kycGender,
                            address: response.data.data?.stpAddressList ? response.data.data?.stpAddressList : null,
                            document: response.data.data?.stpDocumenList ? response.data.data.stpDocumenList : null,
                            kycValid :response.data.data?.kycValid,
                            kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null
                        },
                    });
                    const notCKYCFlow = (dataset?.stpDocumenList?.[0]?.docCode=== "CKYC" &&  dataset?.stpDocumenList?.length === 1) ? false : true ;
                    dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: response.data.data?.stpAddressList[0]?.oclPinCodeFlag === true && notCKYCFlow ? "manual" : user.state === "TR024" && notCKYCFlow ? "digiSplitManual" : "digiAndManual" }, });
                    dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: {stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : ""} });
                    dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""} });
                }
                else {
                    if(dataset?.stpDocumenList && dataset?.stpDocumenList.length > 0 && dataset?.stpDocumenList[0]?.docCode=== "CKYC" ){
                        dispatch({
                        type: types.SAVE_DIGILOCKER_DATA,
                        payload: { gender: response.data.data?.kycGender, address: null, document: dataset?.stpDocumenList, kycValid :response.data.data?.kycValid, kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null },
                    });
                    }
                    else{
                    dispatch({
                        type: types.SAVE_DIGILOCKER_DATA,
                        payload: { gender: response.data.data?.kycGender, address: null, document: null, kycValid :response.data.data?.kycValid,kycCompletedTimestamp:response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null },
                    });
                    }
                    dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
                    dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: {stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : ""} });
                    dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""} });
                }

            if (user.state === "TR001") {
                let addr = getAddress(response.data.data?.stpAddressList, "CKYC");
                dispatch({
                    type: types.SAVE_CKYC_DATA,
                    payload: {
                        applicationNumber: response.data.data?.applicationNumber,
                        resiAddr: addr ? addr[0] : null,
                        gender: response.data.data?.ckycGender,
                        kin: response.data.data?.kin ? response.data.data.kin : "",
                    }
                });
                if (!addr.length) {
                    user.state = "TR002";
                }
            } else if (user.state === "TR003") {
                let addr = getAddress(response.data.data?.stpAddressList, "DEMOG");
                dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: { resiAddr: addr } }, });
                if (addr.length) {
                    dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "demoAndManual" }, });
                } else {
                    dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
                }
            }
            // else if (user.state === "TR010") {
            //   dispatch({ type: types.IS_ACCOUNT_VALIDATION_FAILED, payload: false, });
            // }
            else if (getTrackState(user.state)) {
                if (response.data.data?.downsellCardList || response.data.data?.finalCreditLimit || response.data.data?.posCreditLimit || response.data.data?.stpDocumenList) {
                        const data = {
                        currentCardType: response.data.data?.currentCardType,
                        eligibleCardTypes: response.data.data?.downsellCardList && response.data.data?.downsellCardList.length ? response.data.data.downsellCardList : null,
                        documents: response.data.data?.stpDocumenList,
                        finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit: response.data.data?.finalCreditLimit,
                        stpFlag: response.data.data?.stpFlag,
                        vkycOptFlag : response.data.data?.vkycOptFlag,
                        mitcOtpConsentDate : response.data.data?.mitcOtpConsentDate,
                        vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase():"",
                        vkycAgentDecision :response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase():"",
                        mitcOtpConsentTaken: response.data.data?.mitcOtpConsentTaken,
                        stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : "",
                        faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : "",
                        
                    }
                    dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
                }
                else if(user.state === "TR023") {
                    const data = {
                      currentCardType: response.data.data?.currentCardType,
                        eligibleCardTypes: response.data.data?.downsellCardList && response.data.data?.downsellCardList.length ? response.data.data.downsellCardList : null,
                      documents: response.data.data?.stpDocumenList,
                      finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit: response.data.data?.finalCreditLimit,
                      stpFlag: response.data.data?.stpFlag,
                      vkycOptFlag : response.data.data?.vkycOptFlag,
                      mitcOtpConsentDate : response.data.data?.mitcOtpConsentDate,
                      vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase():"",
                      vkycAgentDecision :response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase():"",
                      faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : "",
                    }
                    dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
                  }
                if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.accountNumber) {
                    dispatch({ type: types.IS_ACCOUNT_VALIDATION_FAILED, payload: false, });
                }
   
                if (user.state === "TR010") {
                    user = { ...user, pennyCreditStatus: true };
                    dispatch({
                        type: types.ACCOUNT_VALIDATION, payload:
                        {
                            "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
                            "nameValidationByBD": true
                        },
                    });
                }
                else if (user.state === "TR008") {
                    user = { ...user, pennyCreditStatus: true, pennyDebitStatus: true };
                    if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.paymentIrn) {
                        localStorage.setItem("paymentIrn", response.data.data.pennyDropDetails.paymentIrn);
                    }
                    dispatch({
                        type: types.ACCOUNT_VALIDATION, payload:
                        {
                            "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
                            "nameValidationByBD": true
                        },
                    });
                }
            }
            else if (user.state === "ERR01" || user.state === "ERR02" || user.state === "ERR03" || user.state === "ERR04" || user.state === "ERR05" || user.state === "ERR06" || user.state === "ERR07" || user.state === "ERR08" || user.state === "ERR09" || user.state === "ERR10" || user.state === "ERR12" || user.state ==="ERR13" || user.state ==="ERR14" || user.state ==="ERR15" || user.state === "ERR16") {
                dispatch({ type: types.SET_WIP_STATUS, payload: { errorCode: user.state }, });
                dispatch({
                    type: types.GENERIC_ERROR,
                    payload: { isGenericError: false, handleClick: null, exitEvent: null, errorMessage: "" },
                });
            }
            let data = {
                posRequired: response.data.data?.posRequired,
                surrogateStatus:response.data.data?.surrogateStatus,
                surrogateList:response.data.data?.surrogateList,
                posCreditLimit:response.data.posCreditLimit,
                finalCreditLimit:response.data.finalCreditLimit,
                gstnList:response.data.data.gstnList,
                aaTriggerCount: response.data.data?.aaTriggerCount
            }
            dispatch({ type: types.SAVE_SURROGATE_DATA,payload:data});
            dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: user, });
            dispatch({ type: types.SAVE_BLAZESTP_ELIGIBLE,payload:response.data.data?.blazeStpEligible});
            if(response.data.data?.cardType && response.data.data?.cardType !== "")
            dispatch({type:types.SAVE_NETWORK_CARDTYPE,payload:response.data.data?.cardType});
            const localHsToken = localStorage.getItem("hsToken");
            localStorage.setItem("hsToken", user?.hsToken ? user.hsToken : localHsToken ? localHsToken : "");
            
            payload = {
                ...initState,
                //isSubmited: true,
                isUserRetrieve: true,
                loading: false,
            };
            errorState = null;
        }
        else {
            payload = { ...initState, isSubmited: true, loading: false, };
            errorState = { errorCode: response.data.statusCode, errorMsg: response.data.message, };
        }
    } else {
        payload = { ...initState, isSubmited: true, loading: false, error: response.data?.message, };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};
